/**
 * アプリ全体で1つの「認証ユーザーの確認」（指示書 A3・④⑨⑩）。
 * ルーターのガード・App・学習者一覧・Top が、同じ確認結果を共有する。仕組みは utils/sharedAuthUser.js。
 * 認証イベントの購読は、このモジュールで1回だけ行う（コールバックの中では同期的に状態を更新するだけ）。
 */

import { supabase } from '../supabaseClient'
import { createSharedAuthUser } from '../utils/sharedAuthUser.js'

const sharedAuthUser = createSharedAuthUser({
  fetchUser: () => supabase.auth.getUser()
})

supabase.auth.onAuthStateChange((event, session) => {
  sharedAuthUser.handleAuthEvent(event, session)
})

/** supabase.auth.getUser() と同じ形の結果（{ data: { user }, error }）を返す。共有・短時間の再利用あり */
export const getAuthUserShared = () => sharedAuthUser.get()

/** ログイン成功の応答で受け取ったユーザーを、確認済みとして登録する */
export const seedAuthUser = (user) => sharedAuthUser.seed(user)

/** 実行中の確認の共有をやめる（Top の読み込みが期限を過ぎたとき。再試行で、止まった確認を待ち直さない） */
export const abandonAuthCheckInFlight = () => sharedAuthUser.abandonInFlight()

/** 確認済みの結果を捨てる（ログアウト時など） */
export const invalidateAuthUser = () => sharedAuthUser.invalidate()
